import { Chip } from '../ui/chip';

interface Props<T extends string> {
  label: string;
  options: ReadonlyArray<{ key: T; label: string }>;
  value: T;
  onChange: (next: T) => void;
}

export function OptionPicker<T extends string>({ label, options, value, onChange }: Props<T>) {
  return (
    <div>
      <p className="mono-label mb-[10px] text-[10px]">{label}</p>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <Chip key={option.key} active={value === option.key} onClick={() => onChange(option.key)}>
            {option.label}
          </Chip>
        ))}
      </div>
    </div>
  );
}
